import * as z from 'zod';

z.config({ jitless: true });
